import { RootState } from "../../store";

export const newCleanResourceTypeSelector = (state: RootState) =>
  state.clean.new?.resourceType;
